import { type FC } from "react";
import {
  StyledRectangleContainer,
  StyledRectangleChildContainer,
  StyledContainer,
  StyledBigRectangleContainer,
} from "./styled";

const CardCarouselPlaceholder: FC = () => {
  return (
    <StyledContainer>
      <Rectangle />
      <BigRectangle />
      <Rectangle />
    </StyledContainer>
  );
};

const Rectangle: FC = () => {
  return (
    <StyledRectangleContainer>
      <StyledRectangleChildContainer
        width={11}
        height={3}
        bgColor="rgba(0, 0, 0, 0.20)"
      />
      <StyledRectangleChildContainer
        width={17}
        height={2}
        bgColor="rgba(0, 0, 0, 0.20);"
      />
      <StyledRectangleChildContainer
        width={15}
        height={2}
        bgColor="rgba(0, 0, 0, 0.20)"
      />
      <StyledRectangleChildContainer
        width={10}
        height={2}
        bgColor="rgba(0, 0, 0, 0.20)"
      />
    </StyledRectangleContainer>
  );
};

const BigRectangle: FC = () => {
  return (
    <StyledBigRectangleContainer>
      <StyledRectangleChildContainer
        width={17}
        height={5}
        bgColor="rgba(0, 0, 0, 0.40)"
      />
      <StyledRectangleChildContainer
        width={26}
        height={3}
        bgColor="rgba(0, 0, 0, 0.20);"
      />
      <StyledRectangleChildContainer
        width={23}
        height={3}
        bgColor="rgba(0, 0, 0, 0.20)"
      />
      <StyledRectangleChildContainer
        width={15}
        height={3}
        bgColor="rgba(0, 0, 0, 0.20)"
      />
    </StyledBigRectangleContainer>
  );
};

export default CardCarouselPlaceholder;
